import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
// import { getText } from '../languageutil/translations';
import { getLanguageBasedImage } from '../languageutil/ImageUtil';
// import { utils, writeFileXLSX } from 'xlsx';
import "./QuizPage.css";

import leftArrow from "../images/LeftArrow.png"
import rightArrow from "../images/RightArrow.png"

// import previousQuestionHover from "../images/tr/PreviousQuestionHover.png"
// import nextQuestionHover from "../images/tr/NextQuestionHover.png"

import twinseyeLogo from "../images/TwinSeye-Logo.png"

const SECTION_CONFIG = {
  tr: {
    sustainability: {
      sections: ["OPERASYON", "ORGANİZASYON", "STRATEJİ", "TEKNOLOJİ"],
      files: ["OperasyonAnaBoyut.json", "OrganizasyonAnaBoyut.json", "StratejiAnaBoyut.json", "TeknolojiAnaBoyut.json"],
      routes: {
        "OPERASYON": "ORGANIZASYON",
        "ORGANİZASYON": "STRATEJI",
        "STRATEJİ": "TEKNOLOJI",
        "TEKNOLOJI": "end"
      }
    },
    strategy: {
      sections: ["STRATEJİ", "TEKNOLOJİ", "ORGANİZASYON", "OPERASYON"],
      files: ["StratejiAnaBoyut.json", "TeknolojiAnaBoyut.json", "OrganizasyonAnaBoyut.json", "OperasyonAnaBoyut.json"],
      routes: {
        "STRATEJİ": "TEKNOLOJİ",
        "TEKNOLOJİ": "ORGANİZASYON",
        "ORGANİZASYON": "OPERASYON",
        "OPERASYON": "end"
      }
    },
    innovation: {
      sections: ["PROBLEM", "İHTİYAÇ", "FIRSAT", "TEHDİT"],
      files: ["ProblemAnaBoyut.json", "IhtiyacAnaBoyut.json", "FirsatAnaBoyut.json", "TehditAnaBoyut.json"],
      routes: {
        "PROBLEM": "İHTİYAÇ",
        "İHTİYAÇ": "FIRSAT",
        "FIRSAT": "TEHDİT",
        "TEHDİT": "end"
      }
    },
    technology: {
      sections: ["OPERASYON", "ORGANİZASYON", "STRATEJİ", "TEKNOLOJİ"],
      files: ["OperasyonAnaBoyut.json", "OrganizasyonAnaBoyut.json", "StratejiAnaBoyut.json", "TeknolojiAnaBoyut.json"],
      routes: {
        "OPERASYON": "ORGANİZASYON",
        "ORGANİZASYON": "STRATEJİ",
        "STRATEJİ": "TEKNOLOJİ",
        "TEKNOLOJİ": "end"
      }
    }
  },
  en: {
    sustainability: {
      sections: ["OPERATION", "ORGANIZATION", "STRATEGY", "TECHNOLOGY"],
      files: ["OperasyonAnaBoyut-en.json", "OrganizasyonAnaBoyut-en.json", "StratejiAnaBoyut-en.json", "TeknolojiAnaBoyut-en.json"],
      routes: {
        "OPERATION": "ORGANIZATION",
        "ORGANIZATION": "STRATEGY",
        "STRATEGY": "TECHNOLOGY",
        "TECHNOLOGY": "end"
      }
    },
    strategy: {
      sections: ["STRATEGY", "TECHNOLOGY", "ORGANIZATION", "OPERATION"],
      files: ["StratejiAnaBoyut-en.json", "TeknolojiAnaBoyut-en.json", "OrganizasyonAnaBoyut-en.json", "OperasyonAnaBoyut-en.json"],
      routes: {
        "STRATEGY": "TECHNOLOGY",
        "TECHNOLOGY": "ORGANIZATION",
        "ORGANIZATION": "OPERATION",
        "OPERATION": "end"
      }
    },
    innovation: {
      sections: ["PROBLEM", "NEED", "OPPORTUNITY", "THREAT"],
      files: ["ProblemAnaBoyut-en.json", "IhtiyacAnaBoyut-en.json", "FirsatAnaBoyut-en.json", "TehditAnaBoyut-en.json"],
      routes: {
        "PROBLEM": "NEED",
        "NEED": "OPPORTUNITY",
        "OPPORTUNITY": "THREAT",
        "THREAT": "end"
      }
    },
    technology: {
      sections: ["OPERATION", "ORGANIZATION", "STRATEGY", "TECHNOLOGY"],
      files: ["OperasyonAnaBoyut-en.json", "OrganizasyonAnaBoyut-en.json", "StratejiAnaBoyut-en.json", "TeknolojiAnaBoyut-en.json"],
      routes: {
        "OPERATION": "ORGANIZATION",
        "ORGANIZATION": "STRATEGY",
        "STRATEGY": "TECHNOLOGY",
        "TECHNOLOGY": "end"
      }
    }
  }
};

function QuizPage({ navigate }) {
  const { quizType, quizFile, sectionName, lastQuestion } = useParams();
  const [quizData, setQuizData] = useState([]);
  const [currentSectionIndex, setCurrentSectionIndex] = useState(0);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [answers, setAnswers] = useState({});
  const [sliderValue, setSliderValue] = useState(3.0);
  const [isFirstBigSection, setIsFirstBigSection] = useState();
  const [isLastBigSection, setIsLastBigSection] = useState();
  const [nextButtonImage, setNextButtonImage] = useState(null);
  const [nextButtonHoverImage, setNextButtonHoverImage] = useState(null);
  const [previousButtonImage, setPreviousButtonImage] = useState(null);
  const [previousButtonHoverImage, setPreviousButtonHoverImage] = useState(null);
  // const [finishButtonImage, setFinishButtonImage] = useState(null);
  // const navigate = useNavigate();

  const updateProgress = async (updatedAnswers) => {
    try {
      const language = localStorage.getItem('language') || 'tr';
      const config = SECTION_CONFIG[language][quizType];
      const bigSectionIndex = config.sections.indexOf(sectionName);
      const companyName = localStorage.getItem('companyName');

      const getResponse = await fetch(`https://corexas-analysis-backend-i1q0.onrender.com/api/progress/${encodeURIComponent(companyName)}`, {
        method: 'GET',
        headers: {
          Authorization: localStorage.getItem('jwt'),
        },
      });

      if (getResponse.ok) {
        const data = await getResponse.json();
        const existingAnswers = data.quizProgress?.[quizType]?.answers || {};

        const mergedAnswers = {
          ...existingAnswers,
          ...updatedAnswers
        };

        const response = await fetch(`https://corexas-analysis-backend-i1q0.onrender.com/api/progress/${encodeURIComponent(companyName)}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: localStorage.getItem('jwt'),
          },
          body: JSON.stringify({
            quizType,
            answers: mergedAnswers,
            currentBigSectionIndex: bigSectionIndex,
            currentSectionIndex,
            currentQuestionIndex,
            latestVisitedRoute: window.location.pathname,
            language // Add language to the request
          }),
        });

        if (!response.ok) {
          console.error('Failed to update progress.');
        }
      }
    } catch (error) {
      console.error('Error updating progress:', error);
    }
  };

  const getQuizFilePath = (quizFile) => {
    const language = localStorage.getItem('language') || 'tr';
    // Don't modify file path if it already has language suffix
    if (quizFile.includes('-en.json')) {
      return quizFile;
    }
    if (language === 'en') {
      // Insert '-en' before the file extension for English files
      return quizFile.replace('.json', '-en.json');
    }
    return quizFile;
  };

  useEffect(() => {
    const filePath = getQuizFilePath(quizFile);
    console.log("Fetching quiz file:", filePath); // Add logging
    fetch(`${process.env.PUBLIC_URL}/assets/quizdata/${quizType}/${filePath}`)
      .then(response => {
        if (!response.ok) {
          throw new Error(`Network response was not ok: ${response.status} ${response.statusText}`);
        }
        return response.json();
      })
      .then(data => setQuizData(data.sections))
      .catch(error => {
        console.error('Error fetching the quiz file:', error);
        console.error('Failed file path:', `${process.env.PUBLIC_URL}/assets/quizdata/${quizType}/${filePath}`);
      });
  }, [quizType, quizFile]);

  const getConfig = () => {
    const language = localStorage.getItem('language') || 'tr';
    return SECTION_CONFIG[language];
  };

  useEffect(() => {
    const fetchProgress = async () => {
      if (quizData.length === 0) {
        return;
      }

      const currentQuizSections = getConfig()[quizType].sections;
      const bigSectionIndex = currentQuizSections.indexOf(sectionName);
      const companyName = localStorage.getItem('companyName');

      if (!companyName) {
        alert('No company name found. Redirecting to login. Currently intro but will be changed.');
        navigate('/intro');
        return;
      }

      try {
        const response = await fetch(`https://corexas-analysis-backend-i1q0.onrender.com/api/progress/${encodeURIComponent(companyName)}`, {
          method: 'GET',
          headers: {
            Authorization: localStorage.getItem('jwt'),
          },
        });

        if (response.ok) {
          const data = await response.json();
          const quizProgressData = data.quizProgress && data.quizProgress[quizType] ? data.quizProgress[quizType] : {};

          // Keep existing answers and only update indices
          setAnswers(prevAnswers => ({
            ...prevAnswers,
            ...quizProgressData.answers
          }));

          if (lastQuestion !== 'last') {
            const isSameBigSection = data.quizProgress[quizType]?.currentBigSectionIndex === bigSectionIndex;
            const sectionIndex = isSameBigSection ? data.quizProgress[quizType]?.currentSectionIndex : 0;
            const questionIndex = isSameBigSection ? data.quizProgress[quizType]?.currentQuestionIndex : 0;

            const validSectionIndex = Math.min(Math.max(sectionIndex, 0), quizData.length - 1);
            setCurrentSectionIndex(validSectionIndex);

            const sectionQuestions = quizData[validSectionIndex]?.questions || [];
            const validQuestionIndex = Math.min(Math.max(questionIndex, 0), sectionQuestions.length - 1);
            setCurrentQuestionIndex(validQuestionIndex);
          }
        } else {
          if (response.status === 404) {
            alert('Company not found. Redirecting to login.');
            navigate('/intro');
          } else if (response.status === 401) {
            alert('Unauthorized. Redirecting to login.');
            navigate('/');
          } else {
            alert('Failed to fetch progress.');
          }
        }
      } catch (error) {
        console.error('Error fetching progress:', error);
        alert('Error fetching progress. Please try again later.');
      }
    }

    fetchProgress();
  }, [navigate, quizType, sectionName, quizData, lastQuestion]);

  const currentSection = quizData[currentSectionIndex];
  const currentQuestion = currentSection?.questions[currentQuestionIndex];

  const handleChange = (value) => {
    const language = localStorage.getItem('language') || 'tr';
    const questionKey = encodeKey(currentQuestion.question);
    const updatedAnswers = {
      ...answers,
      [questionKey]: {
        ...answers[questionKey],
        value: value,
        bigSection: sectionName,
        section: currentSection.name,
        questionNumber: currentQuestionIndex + 1,
        language // Add language to the answer data
      }
    };
    setAnswers(updatedAnswers);
    setSliderValue(parseFloat(value)); // Add this line to update slider value
    localStorage.setItem('quizAnswers', JSON.stringify(updatedAnswers));
    updateProgress(updatedAnswers);
  };

  useEffect(() => {
    // console.log(sliderValue + " and calc: " + ((sliderValue - 10) / 40 * 80 + 10));
    document.documentElement.style.setProperty('--range-value', (sliderValue * 10 - 10) / 40 * 85 + 8 + '%');
    console.log("Current Slider Value:", sliderValue);
  }, [sliderValue])


  const handleTargetChange = (value) => {
    // Remove all characters except numbers and dot
    const sanitizedValue = value.replace(/[^\d.]/g, '');

    // Ensure only one decimal point
    const parts = sanitizedValue.split('.');
    let formattedValue = parts[0] || '';
    if (parts.length > 1) {
      formattedValue += '.' + parts[1].slice(0, 1);
    }

    // Convert to number for validation
    const numValue = parseFloat(formattedValue);

    // Validate range between 1 and 5
    if (!isNaN(numValue) && numValue >= 1 && numValue <= 5) {
      const language = localStorage.getItem('language') || 'tr';
      const questionKey = encodeKey(currentQuestion.question);
      const updatedAnswers = {
        ...answers,
        [questionKey]: {
          ...answers[questionKey],
          targetValue: formattedValue,
          bigSection: sectionName,
          section: currentSection.name,
          questionNumber: currentQuestionIndex + 1,
          language // Add language to the answer data
        }
      };
      setAnswers(updatedAnswers);
      localStorage.setItem('quizAnswers', JSON.stringify(updatedAnswers));
      updateProgress(updatedAnswers);
    } else if (formattedValue === '' || formattedValue === '.') {
      // Allow empty input or single dot while typing
      const updatedAnswers = {
        ...answers,
        [encodeKey(currentQuestion?.question)]: {
          ...answers[encodeKey(currentQuestion?.question)],
          targetValue: formattedValue
        }
      };
      setAnswers(updatedAnswers);
    }
  };


  const handleNext = () => {
    if (currentQuestionIndex < currentSection.questions.length - 1) {
      setCurrentQuestionIndex(prevIndex => {
        const nextIndex = prevIndex + 1;
        // setSliderValue(answers[quizData[currentSectionIndex]?.questions[nextIndex].question] || 3.0); // Reset slider value
        return nextIndex;
      });
    } else if (currentSectionIndex < quizData.length - 1) {
      setCurrentSectionIndex(prevIndex => {
        const nextSectionIndex = prevIndex + 1;
        setCurrentQuestionIndex(0);
        // setSliderValue(answers[quizData[nextSectionIndex]?.questions[0].question] || 3.0); // Reset slider value
        return nextSectionIndex;
      });
    }
    updateProgress(answers, currentSectionIndex, currentQuestionIndex);
  };

  const handlePreviousBigSection = () => {
    const language = localStorage.getItem('language') || 'tr';
    const config = SECTION_CONFIG[language][quizType];
    const currentSectionIndex = config.sections.indexOf(sectionName);
  
    if (currentSectionIndex > 0) {
      const prevSection = config.sections[currentSectionIndex - 1];
      const prevFile = config.files[currentSectionIndex - 1];
  
      fetch(`${process.env.PUBLIC_URL}/assets/quizdata/${quizType}/${prevFile}`)
        .then(response => response.json())
        .then(data => {
          // const lastQuestionIndex = data.sections[data.sections.length - 1].questions.length - 1;
          navigate(`/quiz/${quizType}/${prevFile}/${prevSection}/last`);
        })
        .catch(error => console.error('Error fetching the previous section:', error));
    }
  };

  useEffect(() => {
    if (lastQuestion === 'last' && quizData.length > 0) {
      // Set to the last section
      const lastSectionIndex = quizData.length - 1;
      setCurrentSectionIndex(lastSectionIndex);
      
      // Get the last question index of the last section
      const lastSection = quizData[lastSectionIndex];
      const lastQuestionIndex = lastSection.questions.length - 1;
      
      // Set to the last question
      console.log("Setting to last question index:", lastQuestionIndex);
      setCurrentQuestionIndex(lastQuestionIndex);
    }
  }, [lastQuestion, quizData]);

  const handlePrevious = () => {
    console.log("Handling previous navigation");
    console.log("Current section:", currentSectionIndex, "Current question:", currentQuestionIndex);

    if (currentQuestionIndex > 0) {
      setCurrentQuestionIndex(prevIndex => {
        const prevQuestionIndex = prevIndex - 1;
        setSliderValue(answers[quizData[currentSectionIndex]?.questions[prevQuestionIndex].question] || 3.0);
        updateProgress(answers, currentSectionIndex, currentQuestionIndex);
        return prevQuestionIndex;
      });
    } else if (currentSectionIndex > 0) {
      setCurrentSectionIndex(prevIndex => {
        const prevSectionIndex = prevIndex - 1;
        const lastQuestionIndex = quizData[prevSectionIndex].questions.length - 1;
        setCurrentQuestionIndex(lastQuestionIndex);
        setSliderValue(answers[quizData[prevSectionIndex]?.questions[lastQuestionIndex].question] || 3.0);
        updateProgress(answers, currentSectionIndex, currentQuestionIndex);
        return prevSectionIndex;
      });
    } else if (!isFirstBigSection) {
      console.log("At first question of first section, going to previous big section");
      handlePreviousBigSection();
    }
  };

  const handleJumpToNextSection = () => {
    console.log("Jumping to next section");
    if (currentSectionIndex < quizData.length - 1) {
      setCurrentSectionIndex(prevIndex => {
        const nextSectionIndex = prevIndex + 1;
        setCurrentQuestionIndex(0);
        setSliderValue(answers[quizData[nextSectionIndex]?.questions[0].question] || 3.0); // Reset slider value
        return nextSectionIndex;
      });
    } else {
      handleSave();
    }
  };

  const handleJumpToPreviousSection = () => {
    if (currentSectionIndex > 0) {
      setCurrentSectionIndex(prevIndex => {
        const prevSectionIndex = prevIndex - 1;
        setCurrentQuestionIndex(0);
        setSliderValue(answers[quizData[prevSectionIndex]?.questions[0].question] || 3.0); // Reset slider value
        return prevSectionIndex;
      });
    } else {
      handlePreviousBigSection();
    }
  };

  const handleSave = async () => {
    const language = localStorage.getItem('language') || 'tr';
    const config = SECTION_CONFIG[language][quizType];
    
    const nextSection = config.routes[sectionName];
    let route;
    
    if (nextSection === "end") {
      route = '/intro';
    } else {
      const nextSectionIndex = config.sections.indexOf(nextSection);
      route = `/quiz/${quizType}/${config.files[nextSectionIndex]}/${nextSection}`;
    }
    
    const companyName = localStorage.getItem('companyName');
    try {
      // First get existing progress
      const getResponse = await fetch(`https://corexas-analysis-backend-i1q0.onrender.com/api/progress/${encodeURIComponent(companyName)}`, {
        method: 'GET',
        headers: {
          Authorization: localStorage.getItem('jwt'),
        },
      });
  
      if (getResponse.ok) {
        const data = await getResponse.json();
        const existingAnswers = data.quizProgress?.[quizType]?.answers || {};
  
        const mergedAnswers = {
          ...existingAnswers,
          ...answers
        };
  
        const response = await fetch(`https://corexas-analysis-backend-i1q0.onrender.com/api/progress/${encodeURIComponent(companyName)}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: localStorage.getItem('jwt'),
          },
          body: JSON.stringify({
            latestVisitedRoute: route,
            quizType,
            answers: mergedAnswers,
            language
          }),
        });
        if (!response.ok) {
          console.error('Failed to update progress.');
        }
      }
    } catch (error) {
      console.error('Error updating progress:', error);
    }
  
    navigate(route);
  };

  useEffect(() => {
    const config = getConfig();
    const currentSections = config[quizType].sections;
    const bigSectionIndex = currentSections.indexOf(sectionName);
  
    setIsFirstBigSection(bigSectionIndex <= 0);
    setIsLastBigSection(bigSectionIndex >= currentSections.length - 1);
  }, [quizType, sectionName]);

  const encodeKey = (key) => {
    return key?.replace(/ /g, '_').replace(/\./g, '_dot_');
  };

  // useEffect(() => {
  //   if (Object.keys(answers).length === 0) return;
  //   if (currentQuestion) {
  //     const encodedKey = encodeKey(currentQuestion.question);
  //     console.log("Current Question: " + currentQuestion.question);
  //     console.log("Encoded Key: " + encodedKey);
  //     console.log("Current Answer: " + answers[encodedKey]);
  //     console.log("Answers: " + JSON.stringify(answers));
  //     setSliderValue(answers[encodedKey] || 3.0);
  //   }
  // }, [currentQuestionIndex, currentSectionIndex, answers, currentQuestion, sliderValue]);

  useEffect(() => {
    if (Object.keys(answers).length === 0) return; // Skip if no answers
    if (currentQuestion) {
      const encodedKey = encodeKey(currentQuestion.question); // Encode the key
      const currentValue = answers[encodedKey]?.value || 3.0; // Change this line to access value property
      setSliderValue(parseFloat(currentValue)); // Add parseFloat here
    }
  }, [currentQuestionIndex, currentSectionIndex, answers, currentQuestion]); // Remove `sliderValue` from dependencies

  // useEffect(() => {
  //   if (Object.keys(answers).length === 0) return;
  //   if (currentQuestion) {
  //     console.log("Current Question: " + currentQuestion.question);
  //     console.log("Current Answer: " + answers[currentQuestion.question]);
  //     console.log("Answers: " + JSON.stringify(answers));
  //     setSliderValue(answers[currentQuestion.question] || 3.0);
  //   }
  // }, [currentQuestionIndex, currentSectionIndex, currentQuestion, answers]);

  const getVisibleSections = () => {
    if (quizData.length === 0) return [null, null, null];

    const left = currentSectionIndex > 0 ? quizData[currentSectionIndex - 1] : null;
    const middle = quizData[currentSectionIndex];
    const right = currentSectionIndex < quizData.length - 1 ? quizData[currentSectionIndex + 1] : null;

    return [left, middle, right];
  };

  useEffect(() => {
    if (quizData.length > 0) {
      if (currentSectionIndex >= quizData.length) {
        setCurrentSectionIndex(quizData.length - 1);
      }
      if (currentSectionIndex < 0) {
        setCurrentSectionIndex(0);
      }
      const sectionQuestions = quizData[currentSectionIndex]?.questions || [];
      if (currentQuestionIndex >= sectionQuestions.length) {
        setCurrentQuestionIndex(sectionQuestions.length - 1);
      }
      if (currentQuestionIndex < 0) {
        setCurrentQuestionIndex(0);
      }
    }
  }, [quizData, currentSectionIndex, currentQuestionIndex]);

  // Remove or modify this effect as it's conflicting with the /last logic
  useEffect(() => {
    // Only reset indices if lastQuestion is not 'last'
    if (!lastQuestion && quizData.length > 0) {
      const shouldResetIndices = window.location.pathname.indexOf('/last') === -1;
      if (shouldResetIndices) {
        setCurrentSectionIndex(0);
        setCurrentQuestionIndex(0);
      }
    }
  }, [quizType, quizFile, sectionName, lastQuestion, quizData]);

  // Modify the last question effect to be more robust
  useEffect(() => {
    const goToLastQuestion = () => {
      if (quizData.length > 0) {
        // Set to the last section
        const lastSectionIndex = quizData.length - 1;
        setCurrentSectionIndex(lastSectionIndex);
        
        // Get the last question index of the last section
        const lastSection = quizData[lastSectionIndex];
        const lastQuestionIndex = lastSection.questions.length - 1;
        
        // Set to the last question
        console.log("Setting to last question index:", lastQuestionIndex);
        setCurrentQuestionIndex(lastQuestionIndex);
      }
    };

    if (lastQuestion === 'last' || window.location.pathname.indexOf('/last') !== -1) {
      goToLastQuestion();
    }
  }, [lastQuestion, quizData]);

  const visibleSections = getVisibleSections();

  useEffect(() => {
    setNextButtonImage(getLanguageBasedImage('NextQuestion.png'));
    setPreviousButtonImage(getLanguageBasedImage('PreviousQuestion.png'));
    setNextButtonHoverImage(getLanguageBasedImage('NextQuestionHover.png'));
    setPreviousButtonHoverImage(getLanguageBasedImage('PreviousQuestionHover.png'));
    // setFinishButtonImage(getLanguageBasedImage('BitirButton.png'));
  }, []);

  const getAnswerLevels = () => {
    const language = localStorage.getItem('language') || 'tr';
    if (language === 'en') {
      return [
        "5 - Advanced Level",
        "4 - Mature",
        "3 - Developing",
        "2 - Initial Stage", 
        "1 - Non-Existent"
      ];
    }
    return [
      "5 - İleri Düzey",
      "4 - Olgunlaşmış",
      "3 - Gelişmekte Olan", 
      "2 - İlk Aşama",
      "1 - Var Olmayan"
    ];
  };

  const answerLevels = getAnswerLevels();

  return (
    <div className={"quiz-page"} style={{
      overflow: "hidden", paddingLeft: "20px", paddingRight: "20px", width: "calc(100vw - 40px)", height: "100vh",
      backgroundImage: `linear-gradient(to right, white, #63a3cb, #367db1, #18558b, #121b23, #121b23, #18558b, #367db1, #63a3cb, white)`, backgroundRepeat: "no-repeat", backgroundSize: "cover", backgroundPosition: "center", fontFamily: "arimo",
      alignContent: "center"
    }}>
      <div style={{ maxWidth: "1442px", maxHeight: "691px", justifySelf: "center" }}>
        {quizData.length > 0 && (
          <div className='quiz-page-header' style={{ maxHeight: "105px" }}>
            <div style={{ display: "flex", flexDirection: "row", height: "15vh", width: "100vw", maxWidth: "1442px", maxHeight: "105px" }}>
              <div className='quiz-page-header-left-section' style={{ borderRadius: "15px", borderColor: "#63a3cb", borderWidth: "3px", borderStyle: "solid" }}>
                <div className="TextDiv" style={{ width: "calc(100% - 20px)", height: "40%", display: "flex", alignItems: "center", justifyContent: "space-between", paddingLeft: "10px", borderRadius: "15px" }}>
                  <img alt="" src={twinseyeLogo} style={{ height: "90%", aspectRatio: 1, cursor: "pointer" }} onClick={() => { navigate("/intro"); }} />
                  <p style={{ margin: 0, fontWeight: "bold", fontSize: 40 }}> {sectionName} </p>
                  <img alt="" src={twinseyeLogo} style={{ height: "90%", aspectRatio: 1, cursor: "pointer" }} onClick={() => { navigate("/intro"); }} />
                </div>
                <div className='linear-gradient' style={{ width: "100%", height: "3px", backgroundImage: "linear-gradient(to right, #63a3cb, #367db1, #18558b, #121b23, #121b23, #18558b, #367db1, #63a3cb)" }} />
                <div style={{ display: "flex", flexDirection: "row", height: "60%", justifyContent: "space-between" }}>
                  {!(currentSectionIndex === 0 && isFirstBigSection) &&
                    <img src={leftArrow} alt={""} onClick={handleJumpToPreviousSection} style={{ cursor: "pointer", aspectRatio: 1, height: "70%", alignSelf: "center" }} />}
                  {/* <button onClick={handleJumpToPreviousSection} style={{ width: "10%", height: "100%" }}>Previous Section</button>} */}
                  {(currentSectionIndex === 0 && isFirstBigSection) &&
                    <div style={{ aspectRatio: 1, height: "70%", alignSelf: "center" }} />}

                  <div
                    className="section-names-container"
                    style={{ display: "flex", justifyContent: "space-between", width: "100%" }}
                  >
                    {visibleSections.map((section, index) => {
                      const isActive = quizData.indexOf(section) === currentSectionIndex;

                      return section ? (
                        <p
                          key={`section-${index}`}
                          className={`section-name ${isActive ? 'active-section' : 'inactive-section'}`}
                          onClick={() => {
                            setCurrentSectionIndex(quizData.indexOf(section));
                            setCurrentQuestionIndex(0);
                          }}
                          style={{ flex: 1, textAlign: 'center', cursor: 'pointer', fontSize: "16px" }}
                        >
                          {section.name}
                        </p>
                      ) : (
                        <div key={`spacer-${index}`} style={{ flex: 1 }} />
                      );
                    })}
                  </div>
                  {!(currentSectionIndex === quizData.length - 1 && currentQuestionIndex === currentSection.questions.length - 1 && isLastBigSection) &&
                    <img src={rightArrow} alt='' onClick={handleJumpToNextSection} style={{ cursor: "pointer", aspectRatio: 1, height: "70%", alignSelf: "center" }} />}
                  {(currentSectionIndex === quizData.length - 1 && currentQuestionIndex === currentSection.questions.length - 1 && isLastBigSection) &&
                    <div style={{ width: "10%", height: "100%" }} />}
                </div>
              </div>
              <div className='quiz-page-header-right-section center-items' style={{ borderRadius: "15px", borderColor: "#63a3cb", borderWidth: "3px", borderStyle: "solid", width: "15%" }}>
                <div className="circle linear-gradient-rotated center-items" style={{ height: "90%", aspectRatio: 1 }}>
                  <div className="circle center-items" style={{ height: "70%", aspectRatio: 1, backgroundColor: "white", position: "relative" }}>
                    <p style={{ position: "absolute", top: "0%", fontSize: 12, fontWeight: "bold" }}></p>
                    <input
                      style={{
                        position: "absolute",
                        height: "50%",
                        paddingTop: "10%",
                        background: "transparent",
                        border: "none",
                        textAlign: "center",
                        fontWeight: "bold",
                        fontSize: 20,
                        color: "#110e3e"
                      }}
                      type="text"
                      inputMode="decimal"
                      pattern="[0-9]*[.]?[0-9]?"
                      value={answers[encodeKey(currentQuestion?.question)]?.targetValue || ''}
                      onChange={(e) => handleTargetChange(e.target.value)}
                      onBlur={(e) => {
                        const value = e.target.value;
                        if (value === '' || value === '.') {
                          // Reset to empty if invalid on blur
                          const updatedAnswers = {
                            ...answers,
                            [encodeKey(currentQuestion?.question)]: {
                              ...answers[encodeKey(currentQuestion?.question)],
                              targetValue: ''
                            }
                          };
                          setAnswers(updatedAnswers);
                        }
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        )
        }
        {
          quizData.length > 0 && (
            <div style={{ backgroundColor: "white", height: "calc(85vh - 20px - 13px - 20px - 10px)", marginTop: "15px", paddingTop: "10px", maxHeight: "560px" }}>
              <div style={{ height: "20px", width: "100%" }} />
              <div className="question">
                <div className="runnable-range-outer-div" style={{ position: "relative", left: "-80px", top: "234px", width: "25%", display: "flex", justifyContent: "center", alignItems: "center", maxWidth: "374px" }}>
                {/* <div className="runnable-range-outer-div" style={{ position: "absolute", left: "calc(50vw - 571px - 250px)", top: "calc(50vh + 10%)", width: "25%", display: "flex", justifyContent: "center", alignItems: "center", maxWidth: "374px" }}> */}
                  <input
                    style={{ rotate: "-90deg", height: "100%" }}
                    type="range"
                    id="range"
                    min="1.0"
                    max="5.0"
                    step="0.1"
                    value={answers[encodeKey(currentQuestion?.question)]?.value || 3.0}
                    onChange={(e) => handleChange(e.target.value)}
                  />
                  <span style={{
                    position: 'absolute',
                    // bottom: `${((parseFloat(sliderValue) - 3) * 11.7 + 1.5)}vh`,
                    bottom: `${((parseFloat(sliderValue) - 3) * 183 + 25)}%`,
                    // transform: 'translate(-50%, -100%)',
                    backgroundColor: 'transparent',
                    color: '#110e3e',
                    padding: '4px 8px',
                    borderRadius: '4px',
                    fontSize: '12px',
                    pointerEvents: "none",
                    fontWeight: "bold"
                  }}>
                    {(parseFloat(sliderValue)).toFixed(1)}
                  </span>
                </div>
                <h3 style={{ paddingLeft: "2.5%", marginTop: "-40px" }}>{currentQuestion?.question}</h3>
              </div>
              <div style={{ width: "100%", height: "2px", justifyContent: "center", display: "flex" }}>
                <div className='linear-gradient' style={{ width: "95%", height: "2px" }} />
              </div>

              <div className="answers-container" style={{ paddingLeft: "150px", paddingTop: "40px", height: "50vh", maxHeight: "352px", display: "flex", flexDirection: "column", justifyContent: "space-between", width: "50vw", maxWidth: "800px" }}>
                {currentQuestion?.answers.map((answer, index) => (
                  <div key={index} className="answer" style={{ height: "40px" }}>
                    {index === 4 && <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}> <div style={{ width: "40px", marginRight: "20px", height: "4px", backgroundColor: "#eafcff" }} /> <strong>{answerLevels[4]}</strong> </div>}
                    {index === 3 && <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}> <div style={{ width: "40px", marginRight: "20px", height: "4px", backgroundColor: "#c4eff7" }} /> <strong>{answerLevels[3]}</strong> </div>}
                    {index === 2 && <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}> <div style={{ width: "40px", marginRight: "20px", height: "4px", backgroundColor: "#6e9cb3" }} /> <strong>{answerLevels[2]}</strong> </div>}
                    {index === 1 && <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}> <div style={{ width: "40px", marginRight: "20px", height: "4px", backgroundColor: "#043754" }} /> <strong>{answerLevels[1]}</strong> </div>}
                    {index === 0 && <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}> <div style={{ width: "40px", marginRight: "20px", height: "4px", backgroundColor: "#110e3e" }} /> <strong>{answerLevels[0]}</strong> </div>}
                    {/* <br /> */}
                    <div style={{ paddingLeft: "60px" }} >{answer} </div>
                  </div>
                ))}
              </div>


              <div className="navigation" style={{ width: "30%", position: "relative", display: "flex", justifyContent: "space-between", left: "calc(70% - 30px)", bottom: "20px" }}>
                {(!(currentSectionIndex === 0 && currentQuestionIndex === 0) || !isFirstBigSection) && <img alt="" src={previousButtonImage} style={{ width: "129px", height: "41px", cursor: "pointer" }} onMouseOver={e => (e.currentTarget.src = previousButtonHoverImage)} onMouseOut={e => (e.currentTarget.src = previousButtonImage)} onClick={handlePrevious} />}
                {(currentSectionIndex === 0 && currentQuestionIndex === 0) && <div style={{ width: "129px", height: "41px" }} />}
                
                {/* Always show the next button, including on the last question of the last section in the last big section */}
                <img 
                  alt="" 
                  src={nextButtonImage} 
                  style={{ width: "129px", height: "41px", cursor: "pointer" }} 
                  onMouseOver={e => (e.currentTarget.src = nextButtonHoverImage)} 
                  onMouseOut={e => (e.currentTarget.src = nextButtonImage)} 
                  onClick={() => {
                    // If it's the last question of the last section in the last big section, call handleSave to go to /intro
                    if (currentSectionIndex === quizData.length - 1 && currentQuestionIndex === currentSection.questions.length - 1) {
                      handleSave();
                    } 
                    // If it's the last question of the last section but not the last big section, also call handleSave
                    else if (currentSectionIndex === quizData.length - 1 && currentQuestionIndex === currentSection.questions.length - 1 && !isLastBigSection) {
                      handleSave();
                    } 
                    // Otherwise, proceed to the next question
                    else {
                      handleNext();
                    }
                  }} 
                />
              </div>
            </ div>
          )
        }
      </div>
    </div>
  );
}

export default QuizPage;